<template>
  <b-card no-body class="card-shadow border-0 h-90 width-card">
    <b-row no-gutters class="align-items-center h-100">
      <b-col
        md="12"
        class="d-flex align-items-center justify-content-center rounded-left`"
      >
        <img src="@/assets/img/icons/pie-chart.png" class=" img-fluid" />
      </b-col>
      <b-col md="12">
        <b-card-body class="text-center">
          <b-card-title class="c-black font-weight-lighter fs-18">
            Para ver todas as estatísticas
          </b-card-title>
          <b-card-text class="fs-22 font-weight-bold">
            <router-link :to="{ name: typeRouteById() }">
              Clique aqui
            </router-link>
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'DashboardHomeCard',
  
  methods: {
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-app-estatisticas' : 'lojista-app-estatisticas';
    }
  }
};
</script>

<style scoped>
.card-shadow {
  box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);
}
.width-card {
  height: 290px;
}
</style>